import * as React from "react";
const SvgArrowLarge = (props) => /* @__PURE__ */ React.createElement("svg", { width: 22, height: 20, viewBox: "0 0 22 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.5 0.404297L21 9.9043M21 9.9043L11.5 19.4043M21 9.9043H0", stroke: "currentColor" }));
export default SvgArrowLarge;
